import { jsx as _jsx } from "react/jsx-runtime";
export const LinebreakJSXConverter = {
  linebreak: /*#__PURE__*/_jsx("br", {})
};
//# sourceMappingURL=linebreak.js.map